export const EMAIL_REGEXP = /^[^ ]+@[^ ]+\.[a-z]{2,3}$/

export const MOBILE_PHONE_REGEXP = /^\+?[0-9]{11}$/

export const OFFICE_PHONE_REGEXP = /^[0-9,-]{8}$/
